import { useColorArea } from "@react-aria/color"
import { useFocusRing } from "@react-aria/focus"
import { type ColorAreaProps, useColorAreaState } from "@react-stately/color"
import React from "react"

import styles from "./ColorArea.module.css"

export const ColorArea = (props: ColorAreaProps) => {
  const colorAreaProps = {
    ...props,
    xChannel: "saturation",
    yChannel: "brightness",
  } as const

  const state = useColorAreaState(colorAreaProps)

  const inputXRef = React.useRef(null)
  const inputYRef = React.useRef(null)
  const containerRef = React.useRef(null)

  const {
    colorAreaProps: rootProps,
    xInputProps,
    yInputProps,
    thumbProps,
  } = useColorArea(
    { ...colorAreaProps, inputXRef, inputYRef, containerRef },
    state,
  )

  const { focusProps } = useFocusRing()

  return (
    <div {...rootProps} className={styles.colorAreaSize} ref={containerRef}>
      <div
        {...thumbProps}
        className={styles.thumb}
        style={{
          ...thumbProps.style,
          background: state.getDisplayColor().toString("css"),
        }}
      >
        <input {...xInputProps} {...focusProps} ref={inputXRef} />
        <input {...yInputProps} {...focusProps} ref={inputYRef} />
      </div>
    </div>
  )
}
